// extracted by mini-css-extract-plugin
module.exports = {"discountText":"VolumeDiscount_discountText__SiUOV"};